import { TaskChooseOrganization, TaskResetPassword, TaskSetupMFA, useClerk } from '@clerk/react';

import { authWidgetAppearance } from '@/lib/auth/clerk-appearance';

/**
 * Clerk's screen for the task a pending session still owes, e.g. the password
 * reset Clerk requires after a sign-in with a breached password. Each screen
 * finishes the session and continues to `redirectUrl`.
 */
export function LoginSessionTask({
  taskKey,
  redirectUrl,
}: {
  taskKey: string;
  redirectUrl: string;
}) {
  switch (taskKey) {
    case 'reset-password':
      return (
        <TaskResetPassword redirectUrlComplete={redirectUrl} appearance={authWidgetAppearance} />
      );
    case 'setup-mfa':
      return <TaskSetupMFA redirectUrlComplete={redirectUrl} appearance={authWidgetAppearance} />;
    case 'choose-organization':
      return (
        <TaskChooseOrganization
          redirectUrlComplete={redirectUrl}
          appearance={authWidgetAppearance}
        />
      );
    default:
      return <UnsupportedSessionTask />;
  }
}

/** A task this build has no screen for; signing out is the only safe exit. */
function UnsupportedSessionTask() {
  const clerk = useClerk();
  return (
    <div className="w-full rounded-2xl bg-white p-6 text-center shadow-2xl">
      <p className="text-sm font-semibold text-ink">Your account needs one more step.</p>
      <p className="mt-2 text-sm text-black/55">
        Sign out, then sign in again to finish setting up your account.
      </p>
      <button
        type="button"
        className="mt-5 flex h-11 w-full items-center justify-center rounded-full bg-coral text-sm font-bold text-white shadow-sm transition hover:bg-coral/90"
        onClick={() => void clerk.signOut({ redirectUrl: '/login' })}
      >
        Sign out
      </button>
    </div>
  );
}
